import _defineProperty from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["locale", "formatMessage"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable func-names */
/* eslint-disable import/no-extraneous-dependencies */
import { useIntl as useIntlDefault } from 'gatsby-plugin-intl';
import noIntlFormatBN from '../format-bn';
import noIntlTranslate from '../translate';
var bindFormatLocale = function bindFormatLocale(fn, locale) {
  var context = this;
  return function (bigNumber) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options.locale = locale;
    return fn.call(context, bigNumber, options);
  };
};

// hooks always need to be a function:
var useIntl = function useIntl() {
  var _useIntlDefault = useIntlDefault(),
    locale = _useIntlDefault.locale,
    formatMessage = _useIntlDefault.formatMessage,
    intl = _objectWithoutProperties(_useIntlDefault, _excluded);
  var formatBN = bindFormatLocale(noIntlFormatBN, locale);
  var t = noIntlTranslate.bind(null, formatMessage);
  return _objectSpread(_objectSpread({}, intl), {}, {
    formatBN: formatBN,
    formatMessage: formatMessage,
    locale: locale,
    t: t
  });
};
export default useIntl;